<template>
<div>
  <b-container class="px-0 pt-3" fluid>
         <div v-if="!showModalConfirmation">
          <tutdata v-if="showTutVideo" singlePost="newpreplan" />
          <b-container fluid>
            <b-btn v-if="patchData" variant="outline-info" @click="setupResponseView" :disabled="edit">Response View</b-btn>
            <b-btn v-if="patchData" variant="success" @click="executePrintJS">Print Form</b-btn>
            <b-btn v-if="patchData" @click="emitClosePreplan" variant="danger">Close</b-btn>
                 <b-btn   v-if="patchData && !edit" @click="edit = !edit, getBuildingDataPrevious(savedPreplanData)" :variant="!edit ? 'outline-secondary' : 'secondary'">{{!edit ? 'Edit' : 'Editing' }}</b-btn>
                 <b-btn variant="info" v-show="(!patchData || edit) && requiredValuesCheck(requiredValues).length == 0" @click="patchData == false ? postNewPreplan(ppObj) : (postUpdatePreplan(), edit = !edit)">Save</b-btn>
                  <b-container>
                    <b-row><b-col v-if="!edit">
                     {{ patchData ? 'Last Updated at ' + getFormatedTime + ' by ' + ppObj.preplanAuthor : ''}}
                     </b-col>
                     <b-col v-if="!edit && ppObj && ppObj.preplanSitevisit">
                       Last Site Visit: {{ getFormatedDateTime(ppObj.preplanSitevisit) }}
                     </b-col>
                     <b-col v-if="userData.role == 'fireops' || userData.role == 'adminchief' || userData.role == 'admin' && edit">
                    <b-form-checkbox v-if="patchData" v-show="false" :disabled="ppObj.bridgeAccess && true" v-model="addPreplanToBridge">Add Preplan to Bridge (temp disabled)</b-form-checkbox>
                     </b-col><b-col v-if="userData.role != 'user' &&  edit && patchData">
                     <b-form-checkbox v-model="siteVisitCompleted">Site Visit Completed?</b-form-checkbox>
                     </b-col></b-row>
                    </b-container>
                    <b-container v-if="userData.role != 'user' && edit && scheduledSitevisitData && scheduledSitevisitData.length > 0">
                      <h6 v-if="!siteVisitCompleted" class="text-danger mt-2">There are scheduled site visits for this location</h6>
                      <h6 v-if="siteVisitCompleted" class="mt-2">Select the site visit that was completed</h6>
                      <b-container v-if="siteVisitCompleted">
                        <b-table small :fields="['select', 'scheduled', 'assigned', 'assignedBy']" :items="scheduledSitevisitData">
                          <template slot="select" slot-scope="data">
                            <b-form-checkbox v-model="data.item.select" @input="data.item.delete = false" @change="data.item.delete = false" />
                          </template>
                           <template slot="delete" slot-scope="data">
                            <b-form-checkbox v-model="data.item.delete" @input="data.item.select = false"  @change="data.item.select = false" />
                          </template>
                        </b-table>
                      </b-container>
                    </b-container>
                    <div v-if="formValidationReset" v-show="requiredValuesCheck(requiredValues).length > 0">
                      <span class="text-danger">Required for Submission: 
                        <span v-for="(item, index) in requiredValuesCheck(requiredValues)" :key="index"><em>{{ item.replace(':', '') + ',' }} </em></span></span>
                      
                      </div>
            <b-card no-body :class="responseView ? 'fullScreenSetup' : 'px-0'" >
              <b-container v-if="responseView" fluid class="m-0 p-0">
           <b-container class="p-0 m-0 overflowData" fluid v-if="buildingDataBar">
            <b-navbar  class="blogSpanHeader" type="dark" variant="dark">         
                    <b-nav-form>
                        <b-navbar-brand class="bootstrapTable">Building</b-navbar-brand>
              <b-btn size="sm" class="ml-2" v-for="(btn, index) in formGroups" :disabled="showAll" :variant="showGroup == btn.group ? btn.variant : 'outline-light'" @click="showGroup = btn.group" :key="index">{{ btn.label }}</b-btn>
                        </b-nav-form>
                         <b-navbar-nav class="ml-auto">
                           <b-btn @click="toggleBuildingDataBar" size="sm">Building Data (on)</b-btn>
                        
                         </b-navbar-nav>
                            <b-btn size="sm" class="ml-3" @click="toggleResponseView" variant="danger">Exit</b-btn>
                  </b-navbar>
                    <b-card v-for="(group, index) in formGroups" :key="index"
                      :border-variant="group.variant" v-show="showAll == true ? true : showAll == false && showGroup == group.group ? true : false"
                      :header="group.header"
                      :header-bg-variant="group.variant"
                      header-text-variant="white font-weight-bold p-1"
                      body-text-variant="center"
                      class="p-0" body-class="p-0" header-class="p-0">
                   <b-container breakpoint="lg"
                                fluid
                                label-size="md"
                                label-class="font-weight-bold pt-0"
                                class="mb-0 overFlowResponseView px-1 px-md-4">
                      <template v-for="(display, index) in group.displayOrder">
                        <b-table  stacked="lg" small v-if="display.type == 'table'" :items="getTableItems(display.order, group.fields)"  class="px-1 px-md-4" :key="index" />
                        <div  v-if="display.type == 'textarea'" v-for="(textArea, index2) in group.fields.filter(p => p.order == display.order)" :key="index2">
                        <b-card no-body class="my-1" >{{ holdValues[textArea.vmodel].value }}</b-card>
                        </div>
                        </template>
                                            <b-container fluid v-if="savedPreplanData && savedPreplanData.preplanBusinessIds && getBusinessTableItems(group.group).length > 0" :title="group.header + '(business)'" >
                    <b-container fluid v-for="(business, indexB) in attachedBusinessData" :key="indexB" class="px-1 px-md-4 my-2">
                     <b-card v-for="(bgroup, indexbg) in getBusinessTableItems(group.group)" :key="indexbg"
                      :border-variant="bgroup.variant"
                      :header="business.businessName + ' (' + bgroup.header + ')'"
                      :header-bg-variant="bgroup.variant + '-outline'"
                      :header-text-variant="bgroup.variant + ' font-weight-bold p-1'"
                      body-text-variant="center"
                      class="p-0" body-class="p-0" header-class="p-0">
                      <b-container 
                                breakpoint="lg"
                                fluid
                                label-size="md"
                                label-class="font-weight-bold pt-0"
                                class="mb-0">
                      <template v-for="(display, indexbgd) in bgroup.displayOrder">
                        <b-table  stacked="lg" borderless small v-if="display.type == 'table'" :items="getTableItemsFromBuisness(display.order, bgroup.fields, business)" :key="indexbgd" class="px-1 px-md-4" />
                        <div  v-if="display.type == 'textarea'" v-for="(textArea, index2) in bgroup.fields.filter(p => p.order == display.order)" :key="index2">
                          <b-textarea v-if="getTextAreaItemsFromBuisness(textArea, business)" :value="getTextAreaItemsFromBuisness(textArea, business)" plaintext  />
                        </div>
  
                        </template>
                    </b-container>
                    </b-card>
                    </b-container>
                   </b-container>
                    </b-container>
                    </b-card>

              </b-container>
               <preplanMap v-if="ppObj.preplanBuildingData" :activePreplans="activePreplans" @toggleBuildingDataBar="toggleBuildingDataBar" @updateBuildingLocation="updateBuildingLocation" :attachedBusinessData="attachedBusinessData" :buildingData="ppObj.preplanBuildingData" :edit="edit" :refPhotos="ppObj.preplanPictureArray" :primarySketch="ppObj.preplanBuildingSketch" :responseView="responseView" @updateFeatureData='updateFeatureData($event)' @photoArrayUpdate="photoArrayUpdate($event)" />
              </b-container>
              <b-tabs card v-if="!responseView" >
                  <h6 v-if="showMap && tempBuildingData && tempBuildingDataLatLng == ''">Click on the center of the building to tag the building to this preplan</h6>
                  <b-btn v-if="tempBuildingDataLatLng != ''" variant="success" @click="allowMapPick = false, setBuildingData(tempBuildingDataLatLng), tempBuildingDataLatLng = ''">Set Marker as Building Location</b-btn>
                   <b-tab  title="Address Verification/Set Map" @click="showMap = true, setCadDataSearch(cadData)" :active="responseView" class="px-1 px-md-4">
                 <preplanMap v-if="showMap && ppObj.preplanBuildingData && !moveHoldData" :activePreplans="activePreplans" @updateBuildingLocation="updateBuildingLocation" @updateRoofOptions="updateRoofOptions" :buildingData="ppObj.preplanBuildingData" :attachedBusinessData="attachedBusinessData" :edit="edit" :refPhotos="ppObj.preplanPictureArray" :primarySketch="ppObj.preplanBuildingSketch" :responseView="responseView" @updateFeatureData='updateFeatureData($event)' @photoArrayUpdate="photoArrayUpdate($event)" />
                <preplanMap v-if="showMap && tempBuildingData" :buildingData="tempBuildingData" :activePreplans="activePreplans" :attachedBusinessData="attachedBusinessData" @mapBuildingLatLng="setBuildingLatLng" :edit="edit" :tempView="true" />
                 <b-container v-if="!ppObj.preplanBuildingData" class="px-1 px-md-4">
                     <span v-if="!edit" class="text-info">Click Edit to Add Setup Location Map</span>
                    <b-form-group breakpoint="lg" 
                                label-size="md"
                                label-class="font-weight-bold pt-0"
                                class="mb-0">
                    <b-row class="my-2">
                                            
                      <b-col  v-if="false" v-for="(field, index) in cadData" :key="index" class="mt-2" lg="3" :label-for="field.cadValue"><h6>{{ field.cadValue }}</h6>
                              <b-form-input :disabled="!edit" v-model="field.value" :id="field.cadValue" :type="field.type" ></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input :disabled="!edit" v-model="cadDataSearch" type="text" />
                        <b-btn :disabled="!edit" variant="outline-success" @click="getAddress(cadDataSearch)" >Search For Address</b-btn>
                        <b-btn v-if="false" :disabled="!edit" variant="outline-info" @click="getUserGPSLocation()" >Get Current Location</b-btn>
                        </b-col>
                      </b-row>     
                    </b-form-group>
                    <b-container v-if="addressData.length > 0">
                    <h6 class="font-weight-bold">Verified and Returned Addresses</h6>
                     <b-row v-for="(data, index) in addressData" :key="index">
                       <b-col>{{ data.properties.Place_addr }}</b-col>
                       <b-col cols="*"><b-btn variant="outline-primary" @click="viewMapBuild(data)">Set As Starting Location</b-btn></b-col>
                       <b-col cols="*" v-if="false"><b-btn variant="outline-info" :disabled="allowMapPick" @click="viewMapBuild(data)">Tag Building on Map</b-btn></b-col>
                       </b-row>
                    </b-container>
                    <b-container>
                    <b-row class="mt-5" v-if="searchPerformed && false">
                      <b-col>
                      <h6 class="font-weight-bold text-danger">Unable to Verify Address</h6></b-col>
                       <b-col cols="*"><b-btn variant="outline-danger" @click="allowMapPick = false">Set as Unverified</b-btn></b-col>
                       <b-col cols="*"><b-btn variant="outline-info" :disabled="allowMapPick" @click="viewMapBuild(data)">Tag Building on Map</b-btn></b-col>
                      </b-row></b-container>
                     


                 </b-container>
                 </b-tab>
                 <b-tab title="Building Info" class="px-0 pt-3" :disabled="!patchData && allowMapPick" :active="patchData">
                  <b-btn v-if="edit" v-for="(btn, index) in formGroups" :disabled="showAll" :variant="showGroup == btn.group ? btn.variant : 'outline-' + btn.variant" @click="showGroup = btn.group" :key="index">{{ btn.label }}</b-btn>
                  <b-form-checkbox v-if="edit" v-model="showAll" :value="true" :unchecked-value="false">View All</b-form-checkbox>
                  <b-container class="pt-3 px-1 px-md-4" v-if="edit == true"> 
                    <b-card v-for="(group, index) in formGroups" :key="index"
                      :border-variant="group.variant" v-show="showAll == true ? true : showAll == false && showGroup == group.group ? true : false"
                      :header="group.header"
                      :header-bg-variant="group.variant"
                      header-text-variant="white">
                   <b-form-group breakpoint="lg"
                                label-size="md"
                                label-class="font-weight-bold pt-0"
                                class="mb-0">
                    <b-row class="my-2">
                      <b-col v-for="(field, index) in group.fields" :key="index" class="mt-2" :lg="field.size" :label-for="field.idtag + uniqueKey"><h6>{{ field.label }}</h6>
                        <b-form-input :state="checkForState(field.vmodel)" v-if="(field.type == 'text' || field.type == 'number')" v-model="holdValues[field.vmodel].value" :id="field.idtag + uniqueKey" :type="field.type" @change="updateValue(field.vmodel, $event, field)" ></b-form-input>
                        <b-textarea v-if="field.type == 'textarea'" :id="field.idtag + uniqueKey" v-model="holdValues[field.vmodel].value" :rows="field.rows"  @change="updateValue(field.vmodel, $event)" />
                        <b-form-checkbox v-if="field.type == 'boolean'"  :id="field.idtag + uniqueKey" v-model="holdValues[field.vmodel].value" :value="true" :unchecked-value="false" @change="updateValue(field.vmodel, $event)" />
                              <multiselect v-if="field.type == 'taxonomySingleSelect'"
                                          :class="{'invalidState': !checkForState(field.vmodel), 'validState': checkForState(field.vmodel)}"
                                          :id="field.idtag + uniqueKey"
                                          v-model="holdValues[field.vmodel].value" 
                                          :options="field.tax == 'station' ? stationsData : ''" 
                                          :multiple="field.type == 'taxonomySingleSelect' ? false : true" 
                                          :close-on-select="true" 
                                          :clear-on-select="true"
                                          :hide-selected="true" 
                                          @input="updateValue(field.vmodel, holdValues[field.vmodel].value, field)"
                                          :preserve-search="true" 
                                          :placeholder="'Select ' + field.tax" 
                                          :label="field.tax == 'station' ? 'stationName' : ''" 
                                          :track-by="field.tax == 'station' ? 'stationName' : ''"></multiselect>
                        <b-form-select v-if="field.type == 'select'" v-model="holdValues[field.vmodel].value" :options="getSelectOptions(field.options)" @input="updateValue(field.vmodel, holdValues[field.vmodel].value, field)" />
                        <b-form-input v-if="field.type == 'reference' && refValueSwitch != field.vmodel" :value="holdValues[field.vmodel].value" :id="field.idtag + uniqueKey" disabled></b-form-input>
                      </b-col>
                      </b-row>   
                    </b-form-group>
                   <b-card v-if="group.group == 'business' && resetForm" no-body>
                      <b-tabs card>
                        <b-tab title="available">
                           <b-table :fields="['businessName', {key: 'streetNumberStreetStreetSuffix', label: 'Address'},'updatedAt', 'tag']" :items="availableBusinessReturn" stacked="lg">
                             <template slot="tag" slot-scope="data">
                             <b-btn size="sm" variant="info" @click="taggedBusinessPush(data.item, 'add')">Tag</b-btn>
                             </template>
                             </b-table>
                          </b-tab>
                          <b-tab v-if="taggedBusiness.length > 0" title="Tagged">
                             <b-table :fields="['businessName', {key: 'streetNumberStreetStreetSuffix', label: 'Address'},'updatedAt', 'tag']" :items="taggedBusiness" stacked="lg">
                             <template slot="tag" slot-scope="data" v-if="edit">
                             <b-btn size="sm" variant="danger" @click="taggedBusinessPush(data.item, 'remove')">Remove</b-btn>
                             </template>
                             </b-table>
                          </b-tab>
                        </b-tabs>
                    </b-card>
                    <br><br>
    
                    </b-card>
                      </b-container>
                   
              <b-container class="px-0 pt-3" :class="printReportOn ? 'printReport' : ''" fluid v-if="!edit" :id="'printJS-form' + uniqueKey" >
                  <h4 mt-3 v-if="printReportOn">{{ dataForPrintHeader }}</h4>
                    <b-card v-for="(group, index) in formGroups" :key="index" :id="'printJS-form' + uniqueKey + 'index' + index"
                      :border-variant="group.variant"
                      :header="group.header"
                      :header-bg-variant="group.variant"
                      header-text-variant="white font-weight-bold p-1"
                      body-text-variant="center"
                      class="p-0" body-class="p-0" header-class="p-0">
                   <b-container breakpoint="lg"
                                fluid
                                label-size="md"
                                label-class="font-weight-bold pt-0"
                                class="mb-0 px-1 px-md-4">
                      <template v-for="(display, index) in group.displayOrder">
                        <b-table stacked="lg" small borderless v-if="display.type == 'table'" :items="getTableItems(display.order, group.fields)" :key="index" />
                        <div  v-if="display.type == 'textarea' && holdValues[textArea.vmodel].value" v-for="(textArea, index2) in group.fields.filter(p => p.order == display.order)" :key="index2">
                       
                        <b-card no-body class="my-1" >{{ holdValues[textArea.vmodel].value }}</b-card>
                        </div>
  
                        </template>
                    <b-container fluid v-if="savedPreplanData && savedPreplanData.preplanBusinessIds && getBusinessTableItems(group.group).length > 0" :title="group.header + '(business)'" >
                    <b-container fluid class="my-2 px-1 px-md-4" v-for="(business, indexB) in attachedBusinessData" :key="indexB">
                     <b-card v-for="(bgroup, indexbg) in getBusinessTableItems(group.group)" :key="indexbg"
                      :border-variant="bgroup.variant"
                      :header="business.businessName + ' (' + bgroup.header + ')'"
                      :header-bg-variant="bgroup.variant + '-outline'"
                      :header-text-variant="bgroup.variant + ' font-weight-bold p-1'"
                      body-text-variant="center"
                      class="p-0" body-class="p-0" header-class="p-0">
                      <b-container 
                                breakpoint="lg"
                                fluid
                                label-size="md"
                                label-class="font-weight-bold pt-0"
                                class="mb-0 px-1 px-md-4">
                      <template v-for="(display, indexbgd) in bgroup.displayOrder">
                        <b-table  stacked="lg" borderless small v-if="display.type == 'table'" :items="getTableItemsFromBuisness(display.order, bgroup.fields, business)" :key="indexbgd" />
                        <div  v-if="display.type == 'textarea'" v-for="(textArea, index2) in bgroup.fields.filter(p => p.order == display.order)" :key="index2">
                          <b-textarea v-if="getTextAreaItemsFromBuisness(textArea, business)" :value="getTextAreaItemsFromBuisness(textArea, business)" plaintext  />
                        </div>
  
                        </template>
                    </b-container>
                    </b-card>
                    </b-container>
                   </b-container>
                    </b-container>
                    </b-card>

              </b-container>
               </b-tab>
            
                <b-tab v-if="!responseView" title="Building Sketch" :disabled="!patchData">
                  <b-row class="mb-2">
                    <b-col v-if="buildingSketchSwitch">
                      <span v-if="!edit && !ppObj.preplanBuildingSketch" class="text-info">Click Edit to Add Building Sketch</span>
                      <b-form-file v-if="edit" ref="fileinputSketch" @change="postPreplanSketch"  v-model="pictureUpload" placeholder="Upload or Change Building Sketch" />
                    </b-col>
                    <b-col v-if="!buildingSketchSwitch">
                    <b-form-input v-model="additionalBuildingData" placeholder="Location Description (ie. 2nd, 3rd, Site Plan)" />
                    <b-form-file :disabled="additionalBuildingData == ''" ref="fileinputSketch" @change="postImageBuilding"  v-model="pictureUpload" placeholder="Upload Additional" />
                    </b-col>
                    <b-col v-if="edit && ppObj.preplanBuildingSketch">
                      <b-btn variant="primary" @click="buildingSketchSwitch = !buildingSketchSwitch">{{ buildingSketchSwitch ? "Click to Add Additional Floors or Site Plans" : 'Turn off Add Additioanl Floors/Site Plans' }}</b-btn>
                      </b-col>
                  </b-row>
                    <h5 v-if="ppObj.preplanBuildingSketch">Primary Building Sketch/Layout</h5>
                    <b-img v-if="ppObj.preplanBuildingSketch" fluid :src="ppObj.preplanBuildingSketch" />
                    <div v-for="(pic, index) in filterPictureArray(ppObj.preplanPictureArray, true)" :key="index">
                          <h5 v-if="pic.type && pic.type.id">{{ pic.type.id }}<span v-if="edit"><b-btn class="ml-2" size="sm" variant="danger" @click="removeAdditionalPicture(pic)">X</b-btn></span></h5>
                          <b-img :src="pic.url" fluid />
                      </div>
                      
                  </b-tab>
                <b-tab v-if="!responseView" title="Reference Photos" :disabled="!patchData">
                <b-container class="w-50">
                    <span v-if="!edit" class="text-info">Click Edit to Add Reference Photos</span>
                    
                      <b-form-file v-if="edit" ref="fileinput"  @change="postImage" v-model="pictureUpload" />
   
                      <br>
                </b-container>
                <b-container>
                <b-row v-if="displayItem == 'Loading' || displayItem == 'Compressing'"><b-col align="right" cols="auto" class="pt-1">
                  <span div class="spinner">
                      <div class="bounce1"></div>
                      <div class="bounce2"></div>
                      <div class="bounce3"></div>      
                  </span></b-col><b-col align="left"><h4><strong>{{ displayItem }}</strong></h4></b-col></b-row>
                </b-container>
                <b-container fluid class="maxWidthContainer">
                      <b-carousel 
                                 v-if="ppObj.preplanPictureArray"
                                 id="carousel1"
                                 style="text-shadow: 1px 1px 2px #333;"
                                 controls
                                 
                                 indicators
                                 background="#ababab"
                                v-model="slide"
                               >
                        <template v-for="(pic, index) in filterPictureArray(ppObj.preplanPictureArray)">
                        <b-carousel-slide :key="index" :img-src="pic.url">
                            <p v-for="(details, index2) in pic.type" :key="index2">
                            <strong>{{ details.type }}:</strong> {{ details.location }}</p>
                        </b-carousel-slide>
                        </template>
                      </b-carousel>
                      </b-container>
                </b-tab>
                <b-tab v-if="responseView" title="Switch to Edit View" @click="responseView ? setupResponseView() : ''">
                </b-tab>
                <b-tab v-if="false" title="holdValues">
                  {{ holdValues }}
                  </b-tab>
               <b-tab v-if="false"  title="Data Obj">
                  {{ ppObj }}
                  </b-tab>
              </b-tabs>
            </b-card>
          </b-container>
              </div>
      </b-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { bus } from "../../main";
import Leaf from "leaflet";
import * as esri from "esri-leaflet";
import * as geocode from "esri-leaflet-geocoder"
import axios from "axios";
import printJS from "print-js";
import TutData from "../tracking/deptTutorialsdata.vue";
import DatePicker from "../inputfields/Datepickermod.vue";
import TimePicker from "../inputfields/timepicker.vue";
import moment from "moment";
import Multiselect from "vue-multiselect";
import ImageCompressor from 'image-compressor.js'
import preplanMap from "./preplan/newPreplanMaps.vue";
import html2canvas from 'html2canvas';

export default {
  props: ["preplanId", "savedPreplanData", "viewItem", "formGroups", "formTableStyles", "businessFormGroups", "businessFormTableStyle", "responseViewHold", "createNewPreplanData"],
  components: {
    tutdata: TutData,
    timepicker: TimePicker,
    multiselect: Multiselect,
    datepicker: DatePicker,
    preplanMap
  },
  data() {
    return {
      showTutVideo: false,
      allowMapPick: true,
      searchPerformed: false,
      buildingSketchSwitch: true,
      edit: true,
      slide: 0,
      responseView: false,
      buildingDataBar: true,
      imageResponseData: [],
      postData: "",
      timeData: "",
      imageSrc: "",
      showMap: false,
      cadDataSearch: '',
      moveHoldData: null,
      imageType: "Streets",
      tempBuildingDataLatLng: '',
      taggedBusiness: [],
      mapViewOptions: [
        { text: "Ariel", value: "ImageryTransportation" },
        { text: "2D", value: "Streets" }
      ],
      occupancyOptions: [
              {text: 'PLEASE SELECT OCCUPANCY TYPE', value: '', disabled: true},
              {text: 'Assembly (Fixed seating/Production/Viewing)', value: 'Assembly (Fixed seating / Production/Viewing)'},
              {text: 'Assembly (Restaurants/Nightclubs)', value: 'Assembly (Restaurants/Nightclubs)'},
              {text: 'Assembly (Other Assembly/Gyms/Museums)', value: 'Assembly (Other Assembly/Gyms/Museums)'},
              {text: 'Assembly (Arenas, Pools)', value: 'Assembly (Arenas, Pools)'},	
              {text: 'Assembly (Bleachers, Grandstands)', value: 'Assembly (Bleachers, Grandstands)'},
              {text: 'Business (Offices/Clinics/Goverment)', value: 'Business (Offices/Clinics/Goverment)'},
              {text: 'Educational (Schools ≤ grade 12)', value: 'Educational (Schools ≤ grade 12)'},
              {text: 'Industrial (Moderate Hazards)', value: 'Industrial (Factories with Moderate Hazards)'},
              {text: 'Industrial (Low Hazard, bricks, glass)', value: 'Industrial (Low Hazard, bricks, glass)'},
              {text: 'Storage (Storage with Moderate Hazards (furniture)', value: 'Storage (Storage with Moderate Hazards (furniture)'},
              {text: 'Storage (Storage with Low Hazards (canned goods)', value: 'Storage (Storage with Low Hazards (canned goods)'},
              {text: 'High Hazard (Detonation Hazard (explosives)', value: 'High Hazard (Detonation Hazard (explosives)'},
              {text: 'High Hazard (Accelerated Burning Hazard (flamm. gasses)', value: 'High Hazard (Accelerated Burning Hazard (flamm. gasses)'},
              {text: 'High Hazard (Supported Combustion Hazard (flamm. Solids)', value: 'High Hazard (Supported Combustion Hazard (flamm. Solids)'},
              {text: 'High Hazard (Health Hazards)', value: 'High Hazard (Health Hazards)'},
              {text: 'High Hazard (Semiconductor Fabrications)', value: 'High Hazard (Semiconductor Fabrications)'},
              {text: 'Medical Care Institutional (Nursing Homes)', value: 'Medical Care Institutional (Nursing Homes)'},
              {text: 'Board & Care (Personal Care Services & Lodging)', value: 'Board & Care (Personal Care Services & Lodging)'},
              {text: 'Day-Care (Care & Supervision (>24 hr)', value: 'Day-Care (Care & Supervision (>24 hr)'},
              {text: 'Detention & Correctional (Occupants Under Restraint)', value:  'Detention & Correctional (Occupants Under Restraint)'},
              {text: 'Mercantile (Display, Sale of Goods, Retail)', value: 'Mercantile (Display, Sale of Goods, Retail)'},
              {text: 'Residential (Hotels, Motels, Transient)', value: 'Residential (Hotels, Motels, Transient)'},
              {text: 'Residential (Dormitories)', value: 'Residential (Dormitories)'},
              {text: 'Residential (High Rise/Condo)', value: 'Residential (High Rise/Condo)'},
              {text: 'Residential (Multi-Family)', value: 'Residential (Multi-Family)'},
              {text: 'Residential (Apartments)', value: 'Residential (Apartments)'},
              {text: 'Residential (Boarding)', value: 'Residential (Boarding)'},
              {text: 'Residential (Board & Care, Rehab Facilities)', value: 'Residential (Board & Care, Rehab Facilities)'},
              {text: 'Special Structures (Towers, Tanks)', value: 'Special Structures (Towers, Tanks)'},
              {text: 'OTHER (DOCUMENTED IN TACTICAL PLAN', value: 'OTHER (DOCUMENTED IN TACTICAL PLAN'}
      ],
      constructionOptions: [
        {text: 'PLEASE SELECT CONSTRUCTION TYPE', value: '', disabled: true},
        {text: 'Type 1 (Fire Resistive)', value: 'Type 1 (Fire Resistive)'},
        {text: 'Type 2 (Non-combustible)', value: 'Type 2 (Non-combustible)'},
        {text: 'Type 3 (Ordinary)', value: 'Type 3 (Ordinary)'},
        {text: 'Type 4 (Heavy Timber)', value: 'Type 4 (Heavy Timber)'},
        {text: 'Type 5 (Wood Frame)', value: 'Type 5 (Wood Frame)'},
        {text: 'OTHER (DOCUMENTED IN TACTICAL PLAN', value: 'OTHER (DOCUMENTED IN TACTICAL PLAN'}
      ],
      gpsLocation: {},
      printData: null,
      displayItem: '',
      pictureArraySelectionOption: '',
      refValueSwitch: "",
      stationSelectValue: "",
      showGroup: "building",
      showModalConfirmation: false,
      pictureUpload: "",
      searchData: "",
      holdMapObj: {},
      carouselToggle: "",
      showAll: false,
      pictureFileArray: [],
      imageLoader: "",
      holdValues: {},
      patchData: false,
      completedLoad: false,
      ppObj: {},
      cadData: [],
      cadReset: true,
      checkDisabled: true,
      addressData: [],
      hydrantFeatures: [],
      map: null,
      uniqueKey: '',
      requiredValues: [],
      formValidationReset: true,
      buildingData: null,
      checkDisable: [],
      tempBuildingData: null,
      hydrantPointData: [],
      resetForm: true,
      availableBusiness: [],
      addPreplanToBridge: false,
      siteVisitCompleted: false,
      scheduledSitevisitData: [],
      activePreplans: [],
      printReportOn: false,
      additionalBuildingData: '',
     // availableBusiness: [ { "id": "06eb5010-4156-49db-8516-86e1a07e3db3", "createdAt": "2019-09-11T13:55:31.553Z", "updatedAt": "2019-09-11T13:55:31.553Z", "businessSearchIndex": null, "businessData": [ { "vmodel": "businessName5ic3rl49", "idtag": "businessName", "value": "Value Pawn & Jewelry", "label": "Business Name:", "searchIndex": true }, { "vmodel": "keyholderBusinessNamexs7zqc50", "idtag": "keyholderBusinessName", "value": "James Smith", "label": "Business/Key Holder Name:" }, { "vmodel": "keyholderBusinessNumberua5fbb51", "idtag": "keyholderBusinessNumber", "value": "941-706-4713", "label": "Business/Key Holder Number:" }, { "vmodel": "businessBusinessOwners3w3xs52", "idtag": "businessBusinessOwner", "value": "", "label": "Business Secondary Contact:" }, { "vmodel": "ownerBusinessNumbered2nc253", "idtag": "ownerBusinessNumber", "value": "", "label": "Business Secondary Phone:" }, { "vmodel": "StreetNumber3f1myd54", "idtag": "StreetNumber", "value": "3164", "label": "Street Number:" }, { "vmodel": "Streetbn8ry055", "idtag": "Street", "value": "Bee Ridge", "label": "Street Name:" }, { "vmodel": "Suffixrtum4856", "idtag": "Suffix", "value": "Rd", "label": "Street Suffix:" }, { "vmodel": "Building32238ry055", "idtag": "Building", "value": "", "label": "Building:", "cadOpt": true }, { "vmodel": "Unitrtum4556", "idtag": "Unit", "value": "", "label": "Unit:", "cadOpt": true }, { "vmodel": "City7xgpvk57", "idtag": "City", "value": "Sarasota", "label": "City:" }, { "vmodel": "State5lm01g58", "idtag": "State", "value": "FL", "label": "State:" }, { "vmodel": "Ziplmanxr59", "idtag": "Zip", "value": "34239", "label": "Zip Code:" }, { "vmodel": "Floor3233nxr59", "idtag": "Floor", "value": 1, "label": "Floor Location:" }, { "vmodel": "tacticalBusinessInfo8zpa0n64", "idtag": "tacticalBusinessInfo", "value": "Random Pawned Items", "label": "Business Tactical Info" }, { "vmodel": "sprinklerswt1ebo65", "idtag": "sprinklers", "value": "", "label": "Sprinkers" }, { "vmodel": "fdcLocationag4h4f67", "idtag": "fdcLocation", "value": "", "label": "FDC Location" }, { "vmodel": "standpipea7gsuw66", "idtag": "standpipe", "value": "", "label": "Standpipe" }, { "vmodel": "standpipeRiserLocationa7gsuw66", "idtag": "standpipeRiserLocation", "value": "", "label": "Standpipe/Riser Location" }, { "vmodel": "firepumpktgv1368", "idtag": "firepump", "value": "", "label": "Fire Pump" }, { "vmodel": "firepumpLocation3wa8pw69", "idtag": "firepumpLocation", "value": "", "label": "Fire Pump Location" }, { "vmodel": "knoxboxlalrkx70", "idtag": "knoxbox", "value": true, "label": "Knox Box" }, { "vmodel": "knoxBoxLocation5jfr0971", "idtag": "knoxBoxLocation", "value": "Alphas Side by front door", "label": "Knox Box Location" }, { "vmodel": "facpbyzc4z72", "idtag": "facp", "value": true, "label": "FACP" }, { "vmodel": "facpLocationlmdgul73", "idtag": "facpLocation", "value": "Rear of the structure", "label": "FACP Location" }, { "vmodel": "facpAnnunciatorLocationlmdgul73", "idtag": "facpAnnunciatorLocation", "value": "", "label": "FACP Annunciator Location" }, { "vmodel": "facpContactlmdgul73", "idtag": "facpContact", "value": "Smith's Monitor", "label": "FACP Monitor Company/Info" }, { "vmodel": "facpMaintenanceContactlmdgul73", "idtag": "facpMaintenanceContact", "value": "Monitor Info", "label": "FACP Maintenance Compnay/Info" }, { "vmodel": "facpLastMaintenancelmdgul73", "idtag": "facpLastMaintenance", "value": "2019-09-04", "label": "Last Maintenance Date" }, { "vmodel": "elecmeterLoc9qt01d74", "idtag": "elecmeterLoc", "value": "Rear of the Structure", "label": "Electrical Meter Location" }, { "vmodel": "elecPanelLoci4dv0x75", "idtag": "elecPanelLoc", "value": "Rear of the Structure, ", "label": "Electrical Panel Location" }, { "vmodel": "gasOnSiteujx69h76", "idtag": "gasOnSite", "value": "", "label": "Gas On-site" }, { "vmodel": "gastype9cv6ah77", "idtag": "gastype", "value": "", "label": "Gas Type" }, { "vmodel": "gasShutOffLoce5flns78", "idtag": "gasShutOffLoc", "value": "", "label": "Gas Shut Off Location" }, { "vmodel": "waterShutOffLocglpbkc79", "idtag": "waterShutOffLoc", "value": "", "label": "Water Shut Off Location" }, { "vmodel": "utiOtherj137ip80", "idtag": "utiOther", "value": "", "label": "Other:" }, { "vmodel": "typeBusinessOccupancyd24c1l81", "idtag": "typeBusinessOccupancy", "value": "Business (Offices/Clinics/Goverment)", "label": "Type of Occupancy" }, { "vmodel": "typeOfBusinessConstruction395he182", "idtag": "typeOfBusinessConstruction", "value": "Type 3 (Ordinary)", "label": "Type of Construction" }, { "vmodel": "roofTypeBusiness9zy3sw83", "idtag": "roofType", "value": "Light Weight Truss", "label": "Roof Type" }, { "vmodel": "roofCoverBusinesssp4n8r84", "idtag": "roofCover", "value": "Tar/Paper", "label": "Roof Cover" }, { "vmodel": "roofLoadBusinesstelzu485", "idtag": "roofLoad", "value": "None", "label": "Roof Load" }, { "vmodel": "atticAccessBusinessvjtagb86", "idtag": "atticAccess", "value": "", "label": "Attic Access" }, { "vmodel": "atticAccessLocationBusinesssae23kp87", "idtag": "atticAccessLocations", "value": "", "label": "Location" }, { "vmodel": "demWidthBusiness9sgyfu88", "idtag": "demWidthBusiness", "value": "65", "label": "Business Width:" }, { "vmodel": "demLengthBusinessmcoq0889", "idtag": "demLengthBusiness", "value": "61", "label": "Business Length:" }, { "vmodel": "demHeightBusinesspswjh990", "idtag": "demHeightBusiness", "value": "14", "label": "Business Height:" }, { "vmodel": "CubicFtBusinessozfz4s91", "idtag": "Cubic Ft", "value": "", "label": "Business Cubic Feet:" } ], "businessBuildingData": { "latlng": { "lat": 27.298418022966796, "lng": -82.50734969973566 }, "tactics": [], "hydrants": [], "utilities": [], "fireProtection": [] }, "businessBuildingSketch": "", "businessPictureArray": [], "businessTableData": [ { "key": "businessName", "value": " Value Pawn & Jewelry", "label": "Business Name" }, { "key": "streetNumberStreetStreetSuffix", "value": " 3164 Bee Ridge Rd Sarasota FL 34239", "label": "Address" }, { "key": "map", "obj": { "lat": 27.298418022966796, "lng": -82.50734969973566 }, "point": [ -82.50734969973566, 27.298418022966796 ] } ], "businessAuthorId": "f37771e1-d7f9-43ab-bfd7-29493b0736b3", "businessAuthor": "Rick Wilbert", "businessBusinessIds": null, "businessGisPoint": "0101000020E61000000100E06A78A054C0EB2DA11F654C3B40", "distance": 4.76318843 }, { "id": "74a75b19-3135-44bf-97f0-1d694eaf939d", "createdAt": "2019-09-11T14:01:01.937Z", "updatedAt": "2019-09-11T14:01:01.937Z", "businessSearchIndex": null, "businessData": [ { "vmodel": "businessName5ic3rl49", "idtag": "businessName", "value": "DG Ace Hardware", "label": "Business Name:", "searchIndex": true }, { "vmodel": "keyholderBusinessNamexs7zqc50", "idtag": "keyholderBusinessName", "value": "John Simth", "label": "Business/Key Holder Name:" }, { "vmodel": "keyholderBusinessNumberua5fbb51", "idtag": "keyholderBusinessNumber", "value": "941-924-6614", "label": "Business/Key Holder Number:" }, { "vmodel": "businessBusinessOwners3w3xs52", "idtag": "businessBusinessOwner", "value": "", "label": "Business Secondary Contact:" }, { "vmodel": "ownerBusinessNumbered2nc253", "idtag": "ownerBusinessNumber", "value": "", "label": "Business Secondary Phone:" }, { "vmodel": "StreetNumber3f1myd54", "idtag": "StreetNumber", "value": "3170", "label": "Street Number:" }, { "vmodel": "Streetbn8ry055", "idtag": "Street", "value": "Bee Ridge", "label": "Street Name:" }, { "vmodel": "Suffixrtum4856", "idtag": "Suffix", "value": "Rd", "label": "Street Suffix:" }, { "vmodel": "Building32238ry055", "idtag": "Building", "value": "", "label": "Building:", "cadOpt": true }, { "vmodel": "Unitrtum4556", "idtag": "Unit", "value": "", "label": "Unit:", "cadOpt": true }, { "vmodel": "City7xgpvk57", "idtag": "City", "value": "Sarasota", "label": "City:" }, { "vmodel": "State5lm01g58", "idtag": "State", "value": "FL", "label": "State:" }, { "vmodel": "Ziplmanxr59", "idtag": "Zip", "value": "34239", "label": "Zip Code:" }, { "vmodel": "Floor3233nxr59", "idtag": "Floor", "value": 1, "label": "Floor Location:" }, { "vmodel": "tacticalBusinessInfo8zpa0n64", "idtag": "tacticalBusinessInfo", "value": "Lawn Equipment out back. Large load of paints/flammable liquids.", "label": "Business Tactical Info" }, { "vmodel": "sprinklerswt1ebo65", "idtag": "sprinklers", "value": true, "label": "Sprinkers" }, { "vmodel": "fdcLocationag4h4f67", "idtag": "fdcLocation", "value": "Alpha Side of the Structure", "label": "FDC Location" }, { "vmodel": "standpipea7gsuw66", "idtag": "standpipe", "value": "", "label": "Standpipe" }, { "vmodel": "standpipeRiserLocationa7gsuw66", "idtag": "standpipeRiserLocation", "value": "", "label": "Standpipe/Riser Location" }, { "vmodel": "firepumpktgv1368", "idtag": "firepump", "value": "", "label": "Fire Pump" }, { "vmodel": "firepumpLocation3wa8pw69", "idtag": "firepumpLocation", "value": "", "label": "Fire Pump Location" }, { "vmodel": "knoxboxlalrkx70", "idtag": "knoxbox", "value": "", "label": "Knox Box" }, { "vmodel": "knoxBoxLocation5jfr0971", "idtag": "knoxBoxLocation", "value": "", "label": "Knox Box Location" }, { "vmodel": "facpbyzc4z72", "idtag": "facp", "value": true, "label": "FACP" }, { "vmodel": "facpLocationlmdgul73", "idtag": "facpLocation", "value": "Rear of the Structure", "label": "FACP Location" }, { "vmodel": "facpAnnunciatorLocationlmdgul73", "idtag": "facpAnnunciatorLocation", "value": "", "label": "FACP Annunciator Location" }, { "vmodel": "facpContactlmdgul73", "idtag": "facpContact", "value": "Bobs Monitor Service", "label": "FACP Monitor Company/Info" }, { "vmodel": "facpMaintenanceContactlmdgul73", "idtag": "facpMaintenanceContact", "value": "GulfCoast Monitoring", "label": "FACP Maintenance Compnay/Info" }, { "vmodel": "facpLastMaintenancelmdgul73", "idtag": "facpLastMaintenance", "value": "2019-07-09", "label": "Last Maintenance Date" }, { "vmodel": "elecmeterLoc9qt01d74", "idtag": "elecmeterLoc", "value": "Rear of the structure", "label": "Electrical Meter Location" }, { "vmodel": "elecPanelLoci4dv0x75", "idtag": "elecPanelLoc", "value": "Rear of the Structure inside the door", "label": "Electrical Panel Location" }, { "vmodel": "gasOnSiteujx69h76", "idtag": "gasOnSite", "value": "", "label": "Gas On-site" }, { "vmodel": "gastype9cv6ah77", "idtag": "gastype", "value": "", "label": "Gas Type" }, { "vmodel": "gasShutOffLoce5flns78", "idtag": "gasShutOffLoc", "value": "", "label": "Gas Shut Off Location" }, { "vmodel": "waterShutOffLocglpbkc79", "idtag": "waterShutOffLoc", "value": "", "label": "Water Shut Off Location" }, { "vmodel": "utiOtherj137ip80", "idtag": "utiOther", "value": "", "label": "Other:" }, { "vmodel": "typeBusinessOccupancyd24c1l81", "idtag": "typeBusinessOccupancy", "value": "", "label": "Type of Occupancy" }, { "vmodel": "typeOfBusinessConstruction395he182", "idtag": "typeOfBusinessConstruction", "value": "", "label": "Type of Construction" }, { "vmodel": "roofTypeBusiness9zy3sw83", "idtag": "roofType", "value": "", "label": "Roof Type" }, { "vmodel": "roofCoverBusinesssp4n8r84", "idtag": "roofCover", "value": "", "label": "Roof Cover" }, { "vmodel": "roofLoadBusinesstelzu485", "idtag": "roofLoad", "value": "", "label": "Roof Load" }, { "vmodel": "atticAccessBusinessvjtagb86", "idtag": "atticAccess", "value": "", "label": "Attic Access" }, { "vmodel": "atticAccessLocationBusinesssae23kp87", "idtag": "atticAccessLocations", "value": "", "label": "Location" }, { "vmodel": "demWidthBusiness9sgyfu88", "idtag": "demWidthBusiness", "value": "", "label": "Business Width:" }, { "vmodel": "demLengthBusinessmcoq0889", "idtag": "demLengthBusiness", "value": "", "label": "Business Length:" }, { "vmodel": "demHeightBusinesspswjh990", "idtag": "demHeightBusiness", "value": "", "label": "Business Height:" }, { "vmodel": "CubicFtBusinessozfz4s91", "idtag": "Cubic Ft", "value": "", "label": "Business Cubic Feet:" } ], "businessBuildingData": { "latlng": { "lat": 27.298406813109583, "lng": -82.50716295093298 }, "tactics": [], "hydrants": [], "utilities": [], "fireProtection": [] }, "businessBuildingSketch": "", "businessPictureArray": [], "businessTableData": [ { "key": "businessName", "value": " DG Ace Hardware", "label": "Business Name" }, { "key": "streetNumberStreetStreetSuffix", "value": " 3170 Bee Ridge Rd Sarasota FL 34239", "label": "Address" }, { "key": "map", "obj": { "lat": 27.298406813109583, "lng": -82.50716295093298 }, "point": [ -82.50716295093298, 27.298406813109583 ] } ], "businessAuthorId": "f37771e1-d7f9-43ab-bfd7-29493b0736b3", "businessAuthor": "Rick Wilbert", "businessBusinessIds": null, "businessGisPoint": "0101000020E61000000000985B75A054C091358F63644C3B40", "distance": 14.44465136 }, { "id": "0d628b1c-13b6-4f12-aa32-ebcd74747a73", "createdAt": "2019-08-27T16:34:50.281Z", "updatedAt": "2019-08-27T16:34:50.281Z", "businessSearchIndex": null, "businessData": [ { "vmodel": "businessName5ic3rl49", "idtag": "businessName", "value": "All Appliance Parts Sarasota LLC", "label": "Business Name:", "searchIndex": true }, { "vmodel": "keyholderBusinessNamexs7zqc50", "idtag": "keyholderBusinessName", "value": "John Doe", "label": "Business/Key Holder Name:" }, { "vmodel": "keyholderBusinessNumberua5fbb51", "idtag": "keyholderBusinessNumber", "value": "941-812-2222", "label": "Business/Key Holder Number:" }, { "vmodel": "businessBusinessOwners3w3xs52", "idtag": "businessBusinessOwner", "value": "Sam Doe", "label": "Business Secondary Contact:" }, { "vmodel": "ownerBusinessNumbered2nc253", "idtag": "ownerBusinessNumber", "value": "941-928-1111", "label": "Business Secondary Phone:" }, { "vmodel": "StreetNumber3f1myd54", "idtag": "StreetNumber", "value": "3156", "label": "Street Number:" }, { "vmodel": "Streetbn8ry055", "idtag": "Street", "value": "Bee Ridge", "label": "Street Name:" }, { "vmodel": "Suffixrtum4856", "idtag": "Suffix", "value": "Rd", "label": "Street Suffix:" }, { "vmodel": "Building32238ry055", "idtag": "Building", "value": "", "label": "Building:", "cadOpt": true }, { "vmodel": "Unitrtum4556", "idtag": "Unit", "value": "", "label": "Unit:", "cadOpt": true }, { "vmodel": "City7xgpvk57", "idtag": "City", "value": "Sarasota", "label": "City:" }, { "vmodel": "State5lm01g58", "idtag": "State", "value": "FL", "label": "State:" }, { "vmodel": "Ziplmanxr59", "idtag": "Zip", "value": "34239", "label": "Zip Code:" }, { "vmodel": "Floor3233nxr59", "idtag": "Floor", "value": 1, "label": "Floor Location:" }, { "vmodel": "tacticalBusinessInfo8zpa0n64", "idtag": "tacticalBusinessInfo", "value": "Minimal Appliance Parts, small motors. ", "label": "Business Tactical Info" }, { "vmodel": "sprinklerswt1ebo65", "idtag": "sprinklers", "value": true, "label": "Sprinkers" }, { "vmodel": "fdcLocationag4h4f67", "idtag": "fdcLocation", "value": "", "label": "FDC Location" }, { "vmodel": "standpipea7gsuw66", "idtag": "standpipe", "value": "", "label": "Standpipe" }, { "vmodel": "standpipeRiserLocationa7gsuw66", "idtag": "standpipeRiserLocation", "value": "", "label": "Standpipe/Riser Location" }, { "vmodel": "firepumpktgv1368", "idtag": "firepump", "value": "", "label": "Fire Pump" }, { "vmodel": "firepumpLocation3wa8pw69", "idtag": "firepumpLocation", "value": "", "label": "Fire Pump Location" }, { "vmodel": "knoxboxlalrkx70", "idtag": "knoxbox", "value": "", "label": "Knox Box" }, { "vmodel": "knoxBoxLocation5jfr0971", "idtag": "knoxBoxLocation", "value": "", "label": "Knox Box Location" }, { "vmodel": "facpbyzc4z72", "idtag": "facp", "value": true, "label": "FACP" }, { "vmodel": "facpLocationlmdgul73", "idtag": "facpLocation", "value": "BC Corner", "label": "FACP Location" }, { "vmodel": "facpAnnunciatorLocationlmdgul73", "idtag": "facpAnnunciatorLocation", "value": "", "label": "FACP Annunciator Location" }, { "vmodel": "facpContactlmdgul73", "idtag": "facpContact", "value": "", "label": "FACP Monitor Company/Info" }, { "vmodel": "facpMaintenanceContactlmdgul73", "idtag": "facpMaintenanceContact", "value": "", "label": "FACP Maintenance Compnay/Info" }, { "vmodel": "facpLastMaintenancelmdgul73", "idtag": "facpLastMaintenance", "value": "", "label": "Last Maintenance Date" }, { "vmodel": "elecmeterLoc9qt01d74", "idtag": "elecmeterLoc", "value": "C Rear of the Building", "label": "Electrical Meter Location" }, { "vmodel": "elecPanelLoci4dv0x75", "idtag": "elecPanelLoc", "value": "C Rear of the Store ", "label": "Electrical Panel Location" }, { "vmodel": "gasOnSiteujx69h76", "idtag": "gasOnSite", "value": "", "label": "Gas On-site" }, { "vmodel": "gastype9cv6ah77", "idtag": "gastype", "value": "", "label": "Gas Type" }, { "vmodel": "gasShutOffLoce5flns78", "idtag": "gasShutOffLoc", "value": "", "label": "Gas Shut Off Location" }, { "vmodel": "waterShutOffLocglpbkc79", "idtag": "waterShutOffLoc", "value": "C Rear of the Building", "label": "Water Shut Off Location" }, { "vmodel": "utiOtherj137ip80", "idtag": "utiOther", "value": "", "label": "Other:" }, { "vmodel": "typeBusinessOccupancyd24c1l81", "idtag": "typeBusinessOccupancy", "value": "Business (Offices/Clinics/Goverment)", "label": "Type of Occupancy" }, { "vmodel": "typeOfBusinessConstruction395he182", "idtag": "typeOfBusinessConstruction", "value": "Type 3 (Ordinary)", "label": "Type of Construction" }, { "vmodel": "roofTypeBusiness9zy3sw83", "idtag": "roofType", "value": "Tar Paper", "label": "Roof Type" }, { "vmodel": "roofCoverBusinesssp4n8r84", "idtag": "roofCover", "value": "", "label": "Roof Cover" }, { "vmodel": "roofLoadBusinesstelzu485", "idtag": "roofLoad", "value": "", "label": "Roof Load" }, { "vmodel": "atticAccessBusinessvjtagb86", "idtag": "atticAccess", "value": "", "label": "Attic Access" }, { "vmodel": "atticAccessLocationBusinesssae23kp87", "idtag": "atticAccessLocations", "value": "", "label": "Location" }, { "vmodel": "demWidthBusiness9sgyfu88", "idtag": "demWidthBusiness", "value": "30", "label": "Business Width:" }, { "vmodel": "demLengthBusinessmcoq0889", "idtag": "demLengthBusiness", "value": "60", "label": "Business Length:" }, { "vmodel": "demHeightBusinesspswjh990", "idtag": "demHeightBusiness", "value": "14", "label": "Business Height:" }, { "vmodel": "CubicFtBusinessozfz4s91", "idtag": "Cubic Ft", "value": "", "label": "Business Cubic Feet:" } ], "businessBuildingData": { "latlng": { "lat": 27.29843839436559, "lng": -82.50751096755268 }, "tactics": [], "hydrants": [], "utilities": [], "fireProtection": [] }, "businessBuildingSketch": "", "businessPictureArray": [], "businessTableData": [ { "key": "businessName", "value": " All Appliance Parts Sarasota LLC", "label": "Business Name" }, { "key": "streetNumberStreetStreetSuffix", "value": " 3156 Bee Ridge Rd Sarasota FL 34239", "label": "Address" }, { "key": "map", "obj": { "lat": 27.29843839436559, "lng": -82.50751096755268 }, "point": [ -82.50751096755268, 27.29843839436559 ] } ], "businessAuthorId": "f37771e1-d7f9-43ab-bfd7-29493b0736b3", "businessAuthor": "Rick Wilbert", "businessBusinessIds": null, "businessGisPoint": "0101000020E61000000100480F7BA054C0C4AB6775664C3B40", "distance": 20.34885912 } ],
    };
  },
  created() {
    this.uniqueKey = moment().format('YYYY-MM-DD-HH-mm-ss') + '-preplan'
    this.currentDateSelected = moment().format("MM/DD/YYYY");
    this.currentDateSelectedChange = this.currentDateSelected;
    if(this.responseViewHold){
      this.responseView = this.responseViewHold
      this.buildingDataBar = false
    }
    // var height = window.innerHeight - 100
    if (
      this.savedPreplanData == undefined ||
      this.savedPreplanData == null ||
      this.savedPreplanData == ""
      
    ) {
      this.buildppObjArray(this.formGroups);
      if(this.createNewPreplanData){
        this.updateDataWithBusiness(this.createNewPreplanData)
      }
    } else {
      this.ppObj = this.savedPreplanData
      if(this.savedPreplanData.bridgeAccess){
        this.addPreplanToBridge = true
      }
      if(this.savedPreplanData.preplanBusinessIds){
        this.taggedBusiness = this.savedPreplanData.preplanBusinessIds.map(item => {
              var obj = item
              var holdData = item.businessTableData
                for(var h in holdData){
                      obj[holdData[h].key] = holdData[h].value
                }
              obj['updatedAt'] = moment(obj.updatedAt).format('MM/DD/YY')
              return obj
            })
          }
      this.buildCadData(this.formGroups)
      this.setPreSaveItems(this.savedPreplanData.preplanData, this.formGroups);
      this.patchData = true;
    }
    if (this.viewItem == true) {
      this.edit = false;
    }
    if(this.formTableStyles){
      this.setupDisabledValues(this.formTableStyles)
    }
  },
  mounted() {},
  computed: {
    ...mapState([
      "getSessionData",
      "stationsData",
      "apparatusData",
      "userData",
      "shiftsData",
      "preplanStatus",
      "siteconfig"
    ]),
    dataForPrintHeader(){
      if(this.savedPreplanData && this.savedPreplanData.preplanTableData){
        var data = this.savedPreplanData.preplanTableData
        var keys = ['gridNumber', 'streetNumberStreetStreetSuffix', 'businessName', 'primaryStation']
        var string = ''
        for(var k in keys){
            var item = data.find(p => p.key == keys[k])
            if(item){
              var lead = keys[k] == 'gridNumber' ? 'GRID:' : keys[k] == 'streetNumberStreetStreetSuffix' ? ' ADD:' : keys[k] == 'businessName' ? ' NAME:' : keys[k] == 'primaryStation' ? ' STA:' : null
              var end = keys[k] != 'primaryStation' ? ' |' : ''
              if(lead){ 
                string = string + lead + ' ' + item.value + end
              }
            }
        }
        return string
      } return 'No Data'
    },
    getFormatedTime(){
      var time = this.ppObj.updatedAt
      if(time){
        return moment(time).format('MM/DD/YY - HH:mm')
      } else {
        '***Updated Time Unavailabled'
      }
    },
    availableBusinessReturn(){
  //   console.log(this.taggedBusiness)
      var tagged = this.taggedBusiness.map(p => p.id)
      var array = this.availableBusiness.filter(p => {
        return tagged.indexOf(p.id) == -1
      })
      var holdArray = array.map(item => {
        var obj = item
        var holdData = item.businessTableData
          for(var h in holdData){
                obj[holdData[h].key] = holdData[h].value
          }
        obj['updatedAt'] = moment(obj.updatedAt).format('MM/DD/YY')
        return obj
      })
      return holdArray
    },
    attachedBusinessData() {
      if(this.savedPreplanData && this.savedPreplanData.preplanBusinessIds && this.businessFormTableStyle){
        var holdArray = this.businessFormTableStyle
        var business = this.savedPreplanData.preplanBusinessIds.map(item => {
          var obj = item
          var titleFind = holdArray.find(p => p.itemTitle)
          if(titleFind){
            var titleV = titleFind.values
            var titleItems = []
            for(var t in titleV){
              var tObj = item.businessData.find(p => p.vmodel == titleV)
              if(tObj){
                titleItems.push(tObj)
              }
            }
            var tString = ''
            for(var t in titleItems){
              tString = tString + titleItems[t].value
            }
          }
          obj.title = tString
          var floorFind = holdArray.find(p => p.itemSort)
          if(floorFind && floorFind.values && floorFind.values[0]){
              var floorV = item.businessData.find(p => p.vmodel == floorFind.values[0])
              if(floorV && floorV.value){
                var floor = floorV.value
              } else {
                var floor = 0
              }
          } else {
            var floor = 0
          }
          obj['floor'] = floor
          obj['title'] = tString
          return obj
        })
        return _.orderBy(business, ['businessName'], ['asc'])
      } return []
    },
    formatedDateExport() {
      var dateString = moment(this.currentDateSelected, "MM/DD/YYYY").format(
        "YYYY-MM-DD"
      );
      var timeString = dateString + "T" + this.currentTime;
      var offSet = moment().utcOffset();
      var hourOffSet = offSet * -1 / 60;
      var timeStringForm = moment(timeString).add(hourOffSet, "hours");
      var timeStringAdd = moment(timeStringForm).format("YYYY-MM-DDTHH:mm:ss");
      return timeStringAdd + "Z";
    },
    todaysDate() {
      this.currentDateSelected = moment().format("MM/DD/YYYY");
      return this.currentDateSelected;
    },
    getStationParent() {
      if (
        this.stationSelectValue != "" &&
        this.stationSelectValue != undefined
      ) {
        var parent = this.stationSelectValue.stationParent;
        if (parent != "" && parent != undefined) {
          return parent;
        } else {
          return this.stationSelectValue.stationName;
        }
      } else {
        return "";
      }
    },
  },
  watch: {
    imageSrc(data) {}
  },
  beforeDestroy() {},
  methods: {
    updateDataWithBusiness(data){
      if(data && data.streetNumberStreetStreetSuffix){
        this.cadDataSearch = data.streetNumberStreetStreetSuffix
        this.getAddress(data.streetNumberStreetStreetSuffix)
        var taggedBusiness = [data]
        this.taggedBusiness = taggedBusiness.map(item => {
              var obj = item
              var holdData = item.businessTableData
                for(var h in holdData){
                      obj[holdData[h].key] = holdData[h].value
                }
              obj['updatedAt'] = moment(obj.updatedAt).format('MM/DD/YY')
              return obj
            })
          }
    },
    filterPictureArray(data, boo){
      if(data && !boo){
        return data.filter(p => p.type && p.type.type && p.type.type != 'buildingAdditional')
      }
      if(data && boo){
         return data.filter(p => p.type && p.type.type && p.type.type == 'buildingAdditional')
      }
      return []
    },
    getFormatedDateTime(date){
      if(date){
        return moment(date).format('MM/DD/YYYY')
      } return 'Missing Date Time'
    },
    toggleResponseView(){
      if(this.responseViewHold){
        bus.$emit('closePreplanResponseView')
      } else {
        this.responseView = !this.responseView
      }
    },
    taggedBusinessPush(data, type){
      if(type == 'add'){
      this.taggedBusiness.push(data)
      }
      if(type == 'remove'){
        this.taggedBusiness.splice(this.taggedBusiness.map(p => p.id).indexOf(data.id), 1)
      }
    },
    getSelectOptions(opt){
      return this[opt]
    },
    toggleBuildingDataBar(){
      this.buildingDataBar = !this.buildingDataBar
    },
    setupResponseView(){
      this.responseView = !this.responseView
    },
    requiredValuesCheck(required){
      var data = this.holdValues
      var array = required.filter(p => {
        var index = this.ppObj.preplanData.map(i => i.label).indexOf(p)
        if(!this.holdValues[this.ppObj.preplanData[index].vmodel].value){
          return p
        }
      })
      if(this.taggedBusiness.length == 0){
        array.push('No Tagged Businesses')
        return array
      } else {
        return array
      }
    },
    checkForState(data){
      var index = this.checkDisable.indexOf(data)
      if(index >= 0){
        var holdvalue = this.holdValues[data].value == '' ? false : true
        this.$nextTick(function(){
        this.formValidationReset = true
        })
                return holdvalue
      } else {
        this.formValidationReset = true
        return null
      }

    },
    getBusinessTableItems(data){
      if(this.savedPreplanData && this.savedPreplanData.preplanBusinessIds && this.businessFormGroups){
        return this.businessFormGroups.filter(p => {
          return p.group == data
        })
      } return []
    },
    setupDisabledValues(data){
      var disabledValues = []
      for(var i in data){
        var values = data[i].values
        for(var i in values){
          var obj = this.ppObj.preplanData.find(p => p.vmodel == values[i])
          if(obj.cadOpt != true){
          disabledValues.push(values[i])
          var index = this.ppObj.preplanData.map(p => p.vmodel).indexOf(values[i])
          this.requiredValues.push(this.ppObj.preplanData[index].label)
          }
        }
      }
      this.checkDisable = disabledValues
    },
    emitClosePreplan(){
      this.$emit('closePreplan', this.savedPreplanData.id)
    },
    photoArrayUpdate(data){
      var photo = this.ppObj.preplanPictureArray[data.photoIndex]
      if(data.add && photo.type){
        photo.type.push({id: data.item.id, type: data.item.type, location: data.item.properties.SERVICEADDRESS})
      } else if (data.add){
        photo.type = [{id: data.item.id, type: data.item.type}]
      } else {
        var index = photo.type.map(p => p.id).indexOf(data.item.id)
        if(index >= 0){
          photo.type.splice(index, 1)
        }
      }
    },
    updateFeatureData(data){
      var update = this.ppObj.preplanBuildingData
      update[data.type] = data.data
    },
    updateRoofOptions(data){
      var update = this.ppObj.preplanBuildingData
      update['rooffloortype'] = data
    },
    getBuildingDataPrevious(data){
      if(data && data.preplanBuildingData && data.preplanBuildingData.latlng){
        this.getLocalBusinesses(data.preplanBuildingData.latlng)
      }
      this.checkForSiteVisits(data)
    },
    checkForSiteVisits(data){
      axios({
        method: "get",
        url: "/api/v1/preplan/sitevisit/preplanidopen/" + data.id,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json",
           'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        }
      }).then(response => {
        var mapData = response.data
        if(mapData && mapData.length > 0){
          this.scheduledSitevisitData = mapData.map(item => {
                var obj = item
                obj['select'] = false
                obj['delete'] = false
                obj['assigned'] = this.getTaggedType(item.sitevisitAssignedType, item.sitevisitAssignedId)
                obj['scheduled'] = moment(item.sitevisitDate).format('MM/DD/YY')
                obj['assignedBy'] = item.sitevisitAuthor
                return obj
          })
        }
      });
    },
    getTaggedType(type, id){
      var array = this[type]
      if(array){
      var obj = array.find(p => p.id == id)
      if(obj){
        return type == 'apparatusData' ? obj.apparatusName : type == 'stationsData' ? obj.stationName : type == 'deptContactData' ? obj.firstName + ' ' + obj.lastName : "Unknown"
      } else {
        return null
      }
      } else {
        return null
      }
    },
    setBuildingData(data) {
      if(!this.moveHoldData){
              this.getLocalBusinesses(data)
      var obj = {}
      obj['latlng'] = data
      this.gpsLocation = data
      this.showMap = false
      this.tempBuildingData = null
      this.ppObj['preplanBuildingData'] = obj;
        this.$nextTick(function(){
        this.showMap = true
      })
      } else {
        var obj = _.cloneDeep(this.moveHoldData)
          obj['latlng'] = data
          this.gpsLocation = data
          this.showMap = false
          this.tempBuildingData = null
          this.ppObj['preplanBuildingData'] = obj;
            this.$nextTick(function(){
            this.moveHoldData = null
            this.showMap = true
          })
      }
    },
    getLocalBusinesses(data){
      this.resetForm = false
     axios({
        method: "get",
        url: "/api/v1/preplan/business/find?lat=" + data.lat + '&lng=' + data.lng,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json",
           'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        }
      }).then(response => {
         this.availableBusiness = response.data.filter(p => !p.businessDisabled)
         this.$nextTick(function(){
             this.resetForm = true
         })
      })
    },
    setBuildingLatLng(data){
      this.tempBuildingDataLatLng = {lat: data.lat, lng: data.lng}
    },
    viewMapBuild(data){
            console.log(data)
      var canData = data.properties
      var cadvalues = {"StreetNumber3f1myd54" : "AddNum", "Streetbn8ry055": "StName", "Suffixrtum4856" : "StType", "Building32238ry055" : "BldgName", "Unitrtum4556" : "UnitName", "City7xgpvk57" : "City", "State5lm01g58": "RegionAbbr", "Ziplmanxr59" : "Postal"}
      var items = Object.keys(cadvalues)
      for(var i in items){
          var key = cadvalues[items[i]]
          if(canData[key] && this.holdValues[items[i]]){
            this.holdValues[items[i]].value = canData[key]
            this.updateValue(items[i], canData[key]) 
          }
      }
      this.showMap = false
      this.tempBuildingData = data
      axios({
        method: "get",
        url: "/api/v1/preplan/preplan/find?lat=" + data.latlng.lat + '&lng=' + data.latlng.lng,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json",
           'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        }
      }).then(response => {
         this.activePreplans = response.data
      this.$nextTick(function(){
        this.showMap = true
      })
      });

    },
    updateBuildingLocation(){
    //  console.log(this.ppObj.preplanBuildingData)
      this.showMap = false
      this.moveHoldData = this.ppObj.preplanBuildingData
      this.tempBuildingData = this.ppObj.preplanBuildingData
      this.$nextTick(function(){
        this.showMap = true
      })
    },
    mouseClickEvent(data) {
      console.log(data);
    },
    excutePrintJsNew(){
          var docDefinition = { 
            content: [
              {text: this.dataForPrintHeader,
               style: 'header'
              }
            ],
            	styles: {
                  header: {
                    fontSize: 15,
                    bold: true
                  },
                  subheader: {
                    fontSize: 15,
                    bold: true
                  },
                  quote: {
                    italics: true
                  },
                  small: {
                    fontSize: 8
                  }
                }
	

           };
          var data = this.savedPreplanData
          var groups = this.formGroups
          console.log(data)
          console.log(groups)
          for(var g in groups){
            var group = groups[g]
            var order = group.displayOrder
            var holdInnerTable = []
            for(var o in order){
                var headers = group.fields.filter(p => p.order == order[o].order)
                var heads = headers.map(p => p.label)
                var widths = []
                var values = headers.map(item => {
                        var obj = ''
                        var dataitem = data.preplanData.find(p => p.vmodel == item.vmodel)
                        if(dataitem && dataitem.value && !item.refitem && !item.tax){
                          obj = dataitem.value
                          console.log(item)
                          console.log(obj)
                        }
                        widths.push('*')
                        return obj
                })


              	var obj = {
                  table: {
                  widths: widths,
									body: [
										heads,
										values
									]
								},
              }
              console.log(obj)
              holdInnerTable.push(obj)
            }
            var tableObj = {
              style: 'tableHead',
              table: {
                headerRows: 1,
                dontBreakRows: true,
                widths: ['star'],
                body: [
                  [{text: group.header, style: 'tableHeader', border: [false, true, true, true], fillColor: '#eeeee'}],
                  [holdInnerTable]
                ]
              }

            }
            if(group.header == 'Building Info'){
              docDefinition.content.push(tableObj)
            }

          }
          console.log(docDefinition)
          this.printData = docDefinition
    },
    executePrintJS(event) {
        this.printReportOn = true
        var printId = '#printJS-form' + this.uniqueKey
        var string = this.dataForPrintHeader
        this.$nextTick(function(){
        var documentHold = document.querySelector(printId)
       var obj = {width: documentHold.scrollWidth, height: documentHold.scrollHeight, windowWidth: documentHold.scrollWidth, windowHeight: documentHold.scrollHeight}
       // var obj = {width: 1200, height: documentHold.scrollHeight}
       // console.log(obj)
        html2canvas(documentHold, obj).then(canvas => {
                var image = canvas.toDataURL("image/png")
              printJS({
                            printable: image,
                            type: 'image',
                            style: '@media print { body { margin: 30px, 30px; padding: 30px; color: #000; background-color: #fff; } img {width: 100%; } @page{ size: auto; margin: 0mm; }',
                            //header: 'Shift Command Roster | ' + moment().format('MM/DD/YYYY - HH:mm') + ' | by ' + this.userData.deptRank + ' ' + this.userData.lastName ,
                          })

        }); 
      })
      this.$nextTick(function(){
        this.printReportOn = false
      })
     /**  var string = "Fire Pre-Plan Report";
      return printJS({
        printable: "printJS-form",
        type: "html",
        header: string
      }); */
    },
    buildCadData(groups) {
      var array = [];
      for (var i in groups) {
        var field = groups[i].fields;
        for (var p in field) {
          if (field[p].cad == true) {
           array.push({
              cadValue: field[p].cadValue,
              vmodel: field[p].vmodel
            })
          }
        }
      }
      this.cadData = array
     this.checkForCadValues(array)
   },
    buildppObjArray(groups) {
      var array = [];
      for (var i in groups) {
        var field = groups[i].fields;
        for (var p in field) {
          var obj = { value: "", type: field[p].type };
           if(field[p].default){
            obj.value = field[p].default
          }
          this.holdValues[field[p].vmodel] = obj;
          var newObj = {
            vmodel: field[p].vmodel,
            idtag: field[p].idtag,
            value: "",
            label: field[p].label
          };
          if(field[p].default){
            newObj.value = field[p].default
          }
          if (field[p].type == "reference") {
            newObj["refItem"] = field[p].refitem;
          }
          if (field[p].searchIndex == true) {
            newObj["searchIndex"] = true;
          }
          if(field[p].cadOpt == true){
            newObj["cadOpt"] = true
          }
          if (field[p].type == "taxonomySingleSelect") {
            newObj["taxItem"] = field[p].taxitem;
          }
          if (field[p].cad == true) {
            this.cadData.push({
              cadValue: field[p].cadValue,
              vmodel: field[p].vmodel
            });
          }
          array.push(newObj);
        }
      }
      this.ppObj["preplanData"] = array;
      this.ppObj['preplanBuildingSketch'] =  ''
      this.ppObj['preplanPictureArray'] = []
      this.ppObj['preplanBuildingData'] = null

   },
    getIndexValues(data) {
      var obj = {};
      var fieldSort = data;
      for (var i in fieldSort) {
        if (fieldSort[i].searchIndex == true) {
          var key = fieldSort[i].vmodel;
          var value = fieldSort[i].value;
          if (value != undefined && value != null && value != "") {
            if (value == undefined) {
              value = "Not Entered";
            }
            if (fieldSort[i].type == "computed") {
              value = this.getComputedValues(fieldSort[i]);
            }
            if (fieldSort[i].taxItem) {
              var refval = value[fieldSort[i].taxItem];
              obj[key] = refval;
            
            } else {
              obj[key] = value;
              
            }
          }
        }
      }
      return obj;
    },
    getTableItemsFromBuisness(display, fields, data) {
      var holdValues = data.businessData
      var fieldSort = fields.filter(p => p.order == display && p.preplanData); // && p.preplanData to filter out no
      var obj = {};
      for (var i in fieldSort) {
        var key = fieldSort[i].label;
        var item = holdValues.find(p => p.vmodel == [fieldSort[i].vmodel])
        var value = ''
        if(item && item.value){
          value = item.value
        }
        obj[key] = value;
      }
      var arr = [];
      arr.push(obj);
      return arr;
    },
    getTextAreaItemsFromBuisness(textArea, data){
      var holdValues = data.businessData
      var obj = holdValues.find(p => p.vmodel == textArea.vmodel)
      if(obj && obj.value){
        return obj.value
      }
      return null
    },
    getTableItems(display, fields) {
      var fieldSort = fields.filter(p => p.order == display);
      var obj = {};
      for (var i in fieldSort) {
        var key = fieldSort[i].label;
        var value = this.holdValues[fieldSort[i].vmodel].value;
        if (value == undefined) {
          value = "Not Entered";
        }
        if (fieldSort[i].type == "computed") {
          value = this.getComputedValues(fieldSort[i]);
        }
        if (fieldSort[i].type == "taxonomySingleSelect") {
          value = this.holdValues[fieldSort[i].vmodel].value[
            fieldSort[i].taxitem
          ];
        }
        if (fieldSort[i].type == "reference") {
          value = this.holdValues[fieldSort[i].reference].value[
            fieldSort[i].refitem
          ];
        }
        obj[key] = value;
      }
      var arr = [];
      arr.push(obj);
      return arr;
    },
    getComputedValues(data) {
      var array = [];
      for (var i in data.ref) {
        var hold = this.holdValues[data.ref[i]].value;
        if (hold != undefined && hold != null && hold != "") {
          array.push(hold);
        }
      }
      var operator = function(a, b) {
        return a * b;
      };
      var holdValue = 0;
      for (var i = 0; i < array.length; i++) {
        if (i == 0) {
          var item = operator(array[0], array[1]);

          holdValue = item;
        } else if (i > 1) {
          var item = operator(holdValue, array[i]);
          holdValue = item
        }
      }
      return holdValue;
    },
    setPreSaveItems(data, inputs) {
      var holdObj = {};
      for (var i in inputs) {
        var fields = inputs[i].fields;
        for (var p in fields) {
          var value = this.checkTextAreaValue(fields[p].vmodel);
          var obj = { value: value, type: fields[p].type };
          holdObj[fields[p].vmodel] = obj;
        }

      }
      this.holdValues = holdObj;
    },
    checkTextAreaValue(item) {
      var data = this.ppObj.preplanData;
      var obj = data.find(p => p.vmodel == item);
      if (obj) {
        return obj.value;
      } else {
        return "";
      }
    },
    updateValue(item, value, field) {
      if (field != undefined && field.refBy != undefined) {
        this.updateRefValue(value, field);
      }
      if (field != undefined && field.cad == true) {
        this.checkForCadValues(this.cadData);
      }
      var data = this.ppObj.preplanData.find(p => p.vmodel == item);
      if(data){
        data.value = value;
      } else {
        var newObj = {vmodel: item, value: value}
        this.ppObj.preplanData.push(newObj)
      }
     this.formValidationReset = false
      this.checkForState(item)
    },
    updateRefValue(value, field) {
      var ref = this.ppObj.preplanData.find(p => p.vmodel == [field.refBy]);
      if (ref) {
        this.refValueSwitch = ref.vmodel;
        this.holdValues[ref.vmodel].value = value[ref.refItem];
        ref.value = value[ref.refItem];
        this.$nextTick(function() {
          this.refValueSwitch = "";
        });
      }
    },
    checkForCadValues(data) {
      var hold = this.holdValues;
      var returnNew = false;
      for (var i in data) {
        if (hold[data[i].vmodel]) {
          var value = hold[data[i].vmodel];
          if (value.value) {
            var obj = data[i];
            obj["value"] = value.value;
          } else {
            returnNew = true;
          }
        } else {
         if(this.savedPreplanData.preplanData){
           var savedata = this.savedPreplanData.preplanData
           var index = savedata.map(p => p.vmodel).indexOf(data[i].vmodel)
           if(index >= 0){
             var value = savedata[index].value
             if(value){
               var obj = data[i]
               obj["value"] = value
             }
           }
         }
        }
      }
      if (this.buildingData) {
        var returnNew = false;
      }
      if(this.ppObj.preplanBuildingData){
        var returnNew = false
      }
      this.checkDisabled = returnNew; //returnNew
    },
    modifyCadData(data){
     
    },
    getDescendantProp(obj, desc) {
      var arr = desc.split(".");
      while (arr.length && (obj = obj[arr.shift()]));
      return obj;
    },
    getFiles(obj) {
      this.postImage(obj);
    },
    clearFiles() {
      this.$refs.fileinput.reset();
      this.$refs.fileinputSketch.reset();
      this.displayItem = ''
    },
    setCurrentDate() {
      this.currentDateSelected = moment(this.currentDateSelectedChange).format(
        "MM/DD/YYYY"
      );
    },
    showModalswitchEmitVehicle() {
      this.apparatusSelectValue = "";
      this.stationSelectValue = "";
      this.field_check_details = [];
      this.shiftSelect = "";
      this.checkNumber = [];
      this.currentDivSelection = 1;
      bus.$emit("switchEmitPreplan");
    },
    showModalConfirmationSwitch(event) {
      this.showModalConfirmation = !this.showModalConfirmation;
    },
    showModalConfirmationGet(event) {
      bus.$emit("refreshDomEvent", this.stationSelectValue.name);
      this.$store.dispatch("LOAD_USER_POSTS", this.getSessionData);
      this.showModalConfirmation = !this.showModalConfirmation;
      this.showModalswitchEmitVehicle();
    },
    setCadDataSearch(data){
     var string = ''
     for(var i in data){
       if(data[i].value != '' && data[i].value != undefined){
       string = string + data[i].value + ' '
       }
     }
    this.cadDataSearch = string
    },
    showUserGPSPosition(position){
  //    console.log(position)
      this.showMap = false
      var data = {}
      data['latlng'] = {lat: position.coords.latitude, lng: position.coords.longitude}
      this.tempBuildingData = data
      this.$nextTick(function(){
        this.showMap = true
      })
    //  console.log(position)
    },
    getUserGPSLocation() {
    if (navigator.geolocation) {
      var vm = this
        navigator.geolocation.getCurrentPosition(function(data){
          vm.showUserGPSPosition(data)});
    } else { 
        console.log("Geolocation is not supported by this browser.");
    }
    },
    getAddress(data){
      axios({
        method: 'get',
        url: '/api/v1/preplan/preplan/getarctoken',
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json"
        }
      }).then(response => {
        //console.log(response.data)
     this.getAddressWithKey(data, response.data)
      })

    },  
    getAddressWithKey(data, key) {
      this.searchPerformed = true
      var vm = this
    //  console.log('GEO CODE')
    // could be the free one?
      var arckey = key
      //key
     // console.log(arckey)
      axios({
        method: 'get',
        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?singleLine=' + data + '&forStorage=false&token=' + arckey + '&outFields=*&f=pjson',
        headers: {
          "Content-Type": "application/json"
        }     
      }).then(response => {
         var array = response.data.candidates
       //  console.log(array)
         var filter = array.filter(p => {
           return p.score > 89.5
         })
         vm.addressData = filter.map(item => {
            var obj = {}
            obj.text = item.address
            obj.properties = item.attributes
            obj.score = item.score
            obj.latlng = {lat: item.location.y, lng: item.location.x}
            return obj

         })
      })
    },
    postImage(e){
      this.displayItem = 'Compressing'
      this.imageLoadReset = false
      this.loadingFile = true
      var files = e.target.files || e.dataTransfer.files; 
      this.carouselToggle = false
      if(!files[0]) {
        return;
      }
      var vm = this
      var successReturn = 
       new ImageCompressor(files[0], {
        quality: .6,
        success(result) {
         vm.postImageAxios(result)
        }
        })
      
     },
     removeAdditionalPicture(data){
       var result = confirm('Are You Sure You Want to remove this Picture?')
      if (result) {
       var index = this.ppObj.preplanPictureArray.map(p => p.url).indexOf(data.url)
       if(index >= 0){
         this.ppObj.preplanPictureArray.splice(index, 1)
       } 
      }
     },
    postImageBuilding(e){
      this.displayItem = 'Compressing'
      this.imageLoadReset = false
      this.loadingFile = true
      var files = e.target.files || e.dataTransfer.files; 
      this.carouselToggle = false
      if(!files[0]) {
        return;
      }
      var vm = this
      var successReturn = 
       new ImageCompressor(files[0], {
        quality: .6,
        success(result) {
         vm.postImageAxios(result, true)
        }
        })

     },
    postPreplanSketch(e){
      this.displayItem = 'Compressing'
      this.imageLoadReset = false
      this.loadingFile = true
      var files = e.target.files || e.dataTransfer.files; 
      this.carouselToggle = false
      if(!files[0]) {
        return;
      }
      if(files[0].type != 'application/pdf'){
      var vm = this
      var successReturn = 
       new ImageCompressor(files[0], {
        quality: .8,
        success(result) {
         vm.postImageAxiosSketch(result)
        }
        })
      } else {
      //  this.postImageAxiosSketch(files[0])
      }
     },
    postImageAxiosSketch(e) {
      this.displayItem = 'Uploading'
        var data = new FormData();
        data.append('uploadFile', e);
      axios({
        method: "post",
        url:
          "/api/v1/upload/files/preplan/" +
          this.ppObj.id +
          "/" +
          moment().format("YYYY-MM-DD"),
        data: data,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "multipart/form-data"
        }
      }).then(response => {
        this.ppObj["preplanBuildingSketch"] = this.siteconfig.deptStore + response.data;
        this.clearFiles();
      });
    },
    postImageAxios(e, building) {
         this.displayItem = 'Uploading'
        var data = new FormData();
        data.append('uploadFile', e);
      axios({
        method: "post",
        url:
          "/api/v1/upload/files/preplan/" +
          this.ppObj.id +
          "/" +
          moment().format("YYYY-MM-DD"),
        data: data,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "multipart/form-data"
        }
      }).then(response => {
        var url = response.data
        var type = this.pictureArraySelectionOption
        if(building){
          type = {id: this.additionalBuildingData, type: 'buildingAdditional'}
        }
        var obj = {url: this.siteconfig.deptStore + url, type: type}
        this.ppObj.preplanPictureArray.push(obj)
        this.carouselToggle = true
        this.pictureArraySelectionOption = ''
        this.additionalBuildingData = ''
        this.clearFiles();
      });
    },
    postNewPreplan(data) {
      var dataObj = data
      var holdObjTableData = this.setupTableValues(this.formTableStyles, dataObj)
      dataObj['preplanTableData'] = holdObjTableData
      dataObj['preplanAuthor'] = this.userData.firstName + ' ' + this.userData.lastName
      dataObj['preplanAuthorId'] = this.userData.id
      dataObj['preplanBusinessIds'] = this.taggedBusiness.length > 0 ? this.taggedBusiness.map(p => p.id) : null
      if(this.gpsLocation){
        dataObj['gpsLocation'] = this.gpsLocation
      }
      //   dataObj['preplanSearchIndex'] = this.getIndexValues(dataObj, this.formGroups)
      axios({
        method: "post",
        url: "/api/v1/preplan/preplan",
        data: dataObj,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json"
        }
      }).then(response => {
        this.$emit('savedPrePlanData', response.data[0])
      });
    },
    setupTableValues(table, data){
      var array = []
      for(var p in table){
        var key = table[p].key
        var values = table[p].values
        var label = table[p].label
        var holdValue = this.getValueForItem(data, values)
        array.push({key: key, value: holdValue, label: label})
      }
      if(this.ppObj.preplanBuildingData){
        if(this.ppObj.preplanBuildingData.latlng){
          array.push({key: 'map', obj: this.ppObj.preplanBuildingData.latlng, point: [this.ppObj.preplanBuildingData.latlng.lng, this.ppObj.preplanBuildingData.latlng.lat]})
        }
      }
      return array
    },
    getValueForItem(item, values){
      var data = item.preplanData
      var arrayString = ''
      for(var i in values){
        var dataobj = data.find(p => p.vmodel == values[i]) 
        if(dataobj.taxItem){
          var arrayString = arrayString + ' ' + dataobj.value[dataobj.taxItem]
        } else {
          var arrayString = arrayString + ' ' + dataobj.value
        }
      }
      return arrayString
    },
    checkIfScheduledSiteVisit(){
      var data = this.scheduledSitevisitData.filter(p => p.select)
      if(data && data.length > 0){
        for(var i in data){
          var sendObj = {
              sitevisitComplete: true,
              sitevisitCompletedDate: moment().toISOString(),
              sitevisitAuthor: this.userData.firstName + ' ' + this.userData.lastName,
              sitevisitAuthorId: this.userData.id
          }
          axios({
            method: 'patch',
            url: "/api/v1/preplan/sitevisit/" + data[i].id,
            data: sendObj,
            headers: {
              Authorization: this.getSessionData,
              "Content-Type": "application/json"
              }

          }).then(resposne => {
              console.log(reponse.data)
          })
        }
      }
    },
    postUpdatePreplan() {
      var dataObj = this.ppObj;
      this.showMap = false
      var holdObjTableData = this.setupTableValues(this.formTableStyles, dataObj)
      dataObj['preplanTableData'] = holdObjTableData
      dataObj['preplanAuthor'] = this.userData.firstName + ' ' + this.userData.lastName
      dataObj['preplanAuthorId'] = this.userData.id
      dataObj['preplanBusinessIds'] = this.taggedBusiness.length > 0 ? this.taggedBusiness.map(p => p.id) : null
      if(this.addPreplanToBridge || dataObj.bridgeAccess){
      dataObj['arcGisPost'] = true
      }
      if(this.siteVisitCompleted){
      dataObj['preplanSitevisit'] = moment().toISOString()
      }
      if(this.scheduledSitevisitData){
        this.checkIfScheduledSiteVisit()
      }
     // dataObj["preplanSearchIndex"] = this.getIndexValues(dataObj.preplanData);
      axios({
        method: "patch",
        url: "/api/v1/preplan/preplan/" + dataObj.id,
        data: dataObj,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json"
        }
      }).then(response => {
          if(!this.addPreplanToBridge){
          this.$emit('reloadPreplan', response.data[0].id)
          } else {
          this.$emit('reloadPreplanGis', response.data[0].id)
          }
      });

    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight {
  background: #f0454a;
}
span.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 10px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #f0454a;
  margin-bottom: 8px;
  white-space: nowrap;
}
span.custom__remove {
  color: #444;
  font-weight: bold;
  margin-left: 3px;
  font-size: 14px;
  cursor: pointer;
}
</style>
<style scoped>
.overflowData {
  overflow: hidden;
    position: fixed;
    z-index: 900;
}
.overFlowResponseView {
  overflow: auto;
  max-height: 80vh;
}
.fullScreenSetup {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 8000;
}
.maxWidthContainer {
  max-width: 500px;
}
.printReport {
  width: 1200px !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0 !important;
  margin: 0 !important;
  z-index: 9999;
  background: #fff;
  height: auto;
}
.invalidState {
  border: 1px solid red;
  border-radius: 5px;
}
.validState {
  border: 1px solid green;
  border-radius: 5px;
}
.spinner {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #333;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.textAreaDescription {
  margin-top: 10px;
}
.iconAddMapp {
  width: 50px;
}
span {
  margin-bottom: 10px;
}
.multiselect {
  margin-bottom: 15px;
}
.itemDescription {
  margin-top: 10px;
  border-style: solid;
  border: 1px solid #bbb;
}
#tablePassDown {
  margin: 0;
  padding: 0;
}
.sub-section-heading {
  color: White;
  background: #aaa;
  width: 100%;
  border-radius: 5px;
  padding: 7px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 0;
  margin-left: 0;
}
textarea {
  width: 100%;
  border-radius: 5px;
}
.centerTheHeading {
  text-align: center;
}
.genLeft h3 {
  margin-right: 30px;
  text-align: right;
}
.genCenter {
  text-align: center;
}
.removeButton {
  background: white;
  color: red;
  border: 1px solid red;
  border-radius: 50%;
  margin: 0;
}
input {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
}
span.defDescrip {
  border: 1px solid red;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  margin-left: 40px;
}
span.Yes {
  background: green;
  color: white;
  padding: 3px;
}
span.No {
  background: red;
  color: white;
  padding: 3px;
}
table {
  width: 100%;
  text-align: center;
}
tr.headerRows {
  background: #aaa;
  font-weight: bold;
}
#confirmationTable td {
  padding: 5px;
}
.selectedButtonGreen {
  background: green;
  color: white;
}
.selectedButtonRed {
  background: red;
  color: white;
}
#todaysDateDisplay {
  margin-bottom: 0;
  cursor: pointer;
  color: red;
}
#logbookBody {
  margin-top: 60px;
  width: 100%;
}
.addNewArticle {
  border-radius: 50%;
}
.addNewArticle:hover {
  background: grey;
}
.timeMobile {
  display: none;
}
@media screen and (max-width: 920px) {
  .time-picker.timeDesk {
    display: none;
  }
  .timeMobile {
    display: block;
    min-width: 120px;
    max-width: 150px;
  }
}
</style>
